import { AutogenModelMatchTrailerType, AutogenRowMatchTrailerType } from "./autogen/AutogenModelMatchTrailerType";

export class ModelMatchTrailerType extends AutogenModelMatchTrailerType<RowMatchTrailerType> {
	constructor() {
		super(RowMatchTrailerType);
	}
}

export class RowMatchTrailerType extends AutogenRowMatchTrailerType {
}